import { Button } from '@one-thd/sui-atomic-components';
import React, { memo } from 'react';
import { AddReceiptDrawer } from './add-receipt';
import { usePurchaseHistoryContext } from '../../../hooks/useContexts';
import { pushEventInfo } from '../../../utils/analytics';
import { IAddReceipt } from '../../../models/purchase-history';

export const AddReceiptButton = memo(
  ({ svocId, mobile = false }: IAddReceipt) => {
    const { openAddReceiptDrawer, setOpenAddReceiptDrawer } =
      usePurchaseHistoryContext();
    return (
      <div data-testid="add-receipt-button">
        {mobile ? (
          <Button
            variant="secondary"
            onClick={() => {
              pushEventInfo({
                category: { primaryCategory: 'overlay' },
                eventInfo: { eventName: 'add receipt' },
              });
              setOpenAddReceiptDrawer(true);
            }}
          >
            Add Receipt
          </Button>
        ) : (
          <Button
            variant="primary"
            onClick={() => {
              pushEventInfo({
                category: { primaryCategory: 'overlay' },
                eventInfo: { eventName: 'add receipt' },
              });
              setOpenAddReceiptDrawer(true);
            }}
          >
            Add Receipt
          </Button>
        )}

        <AddReceiptDrawer
          closeDrawer={() => setOpenAddReceiptDrawer(false)}
          isDrawerOpen={openAddReceiptDrawer}
          svocId={svocId}
        />
      </div>
    );
  },
);
